var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('adx-top-alert',{ref:"alert",attrs:{"status":_vm.status,"message":_vm.message,"visible":"visible"}}),_c('button',{on:{"click":_vm.show}},[_vm._v("Show")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }